import React, { Component } from 'react';
import Header from '../decoration/header';
import CatagoryPanel from './catagoryPanel';
import Footer from '../footer/footer';

import './catagory.css';
import GeneralPopup from '../PopupComponent/GeneralPopup';

class Catagory extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showPopup: true,
		};

		this.onPopupClicked = this.onPopupClicked.bind(this);
	}

	onPopupClicked() {
		this.setState({
			showPopup: false,
		});
	}

	render() {
		const { showPopup } = this.state;
		return (
			<div>
				<Header />
				<div className="catagory">
					{/* <GeneralPopup
						showPopup={showPopup}
						onCloseClick={this.onPopupClicked}
					/> */}
					<CatagoryPanel />
				</div>
				<Footer />
			</div>
	    );
	}
}

export default Catagory;



// WEBPACK FOOTER //
// ./src/components/catagory/catagory.js